import { useQuery } from '@tanstack/react-query';
import { configService } from '../api/configService';
import { queryKey } from '../constant';

export const useConfigs = () => {
  return useQuery({
    queryKey: queryKey.configs,
    queryFn: () => configService.getConfigs(),
  });
};
